import { getFirestore, collection, doc, getDocs, addDoc, deleteDoc, query, where, } from "firebase/firestore";
import { mapFirebaseError } from "./errorMapper";
import { favoriteDTOtoDomain } from "./mappers";
export class FirebaseFavoritesRepository {
    db = getFirestore();
    coll = collection(this.db, "favorites");
    async fetchAll(userId) {
        try {
            const q = query(this.coll, where("userId", "==", userId));
            const snap = await getDocs(q);
            return snap.docs.map((d) => favoriteDTOtoDomain(d.id, d.data()));
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async favoriteId(userId, serviceId) {
        try {
            const q = query(this.coll, where("userId", "==", userId), where("serviceId", "==", serviceId));
            const snap = await getDocs(q);
            if (snap.empty)
                return null;
            return snap.docs[0].id;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async add(userId, serviceId) {
        try {
            const ref = await addDoc(this.coll, { userId, serviceId });
            return ref.id;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async remove(favoriteId) {
        try {
            await deleteDoc(doc(this.coll, favoriteId));
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseFavoritesRepository.js.map